module.exports = __webpack_public_path__ + "static/media/not-alert.efee6139.svg";